import { integerRegExp, positiveRegExp } from '@/utils/reg-exp'
const nullOptions = [
  {
    value: 'is_null',
    label: '为空'
  },
  {
    value: 'not_null',
    label: '不为空'
  }
]
const comparedOptions = [
  {
    value: 'eq',
    label: '等于'
  },
  {
    value: 'ne',
    label: '不等于'
  },
  {
    value: 'gt',
    label: '大于',
    types: ['RATE']
  },
  {
    value: 'ge',
    label: '大于等于',
    types: ['RATE']
  },
  {
    value: 'lt',
    label: '小于',
    types: ['RATE']
  },
  {
    value: 'le',
    label: '小于等于',
    types: ['RATE']
  },
  ...nullOptions
]
const dateOptions = [
  {
    value: 'lt',
    label: '之前'
  },
  {
    value: 'gt',
    label: '之后'
  },
  {
    value: 'between',
    label: '介于'
  },
  ...nullOptions
]
export const componentTypes = [
  {
    typeIds: ['NUMBER'],
    conditionOptions: comparedOptions,
    regExp: integerRegExp
  },
  {
    typeIds: ['RATE', 'SLIDER', 'NPS'],
    conditionOptions: comparedOptions,
    regExp: positiveRegExp
  },
  {
    typeIds: ['DATE'],
    conditionOptions: dateOptions
  },
  {
    typeIds: ['RADIO', 'SELECT', 'CASCADER'],
    conditionOptions: [
      {
        value: 'contain',
        label: '包含'
      },
      ...nullOptions
    ]
  },
  {
    typeIds: ['CHECKBOX'],
    conditionOptions: [
      {
        value: 'contain',
        label: '包含'
      },
      {
        value: 'not_contain',
        label: '不包含'
      },
      ...nullOptions
    ]
  },
  {
    typeIds: ['INPUT', 'TEXTAREA'],
    conditionOptions: [
      {
        value: 'contain_keywords',
        label: '包含'
      },
      {
        value: 'not_contain',
        label: '不包含'
      },
      ...nullOptions
    ]
  }
]
